import type { Card } from '../../shared/doc.js';
import { assetUrl } from '../api.js';

const STALE_MS = 30_000;

export function LinkCard({ card, onRetry }: { card: Extract<Card, { kind: 'link' }>; onRetry: () => void }) {
  const host = (() => {
    try {
      return new URL(card.url).hostname.replace(/^www\./, '');
    } catch {
      return card.url;
    }
  })();
  const pendingTooLong = card.previewStatus === 'pending' && Date.now() - Date.parse(card.createdAt) > STALE_MS;
  return (
    <div className="link-card">
      {card.imageAssetId && <img src={assetUrl(card.imageAssetId)} alt="" draggable={false} />}
      <a href={card.url} target="_blank" rel="noopener noreferrer" onPointerDown={(e) => e.stopPropagation()}>
        {card.title || host}
      </a>
      <small>{card.siteName || host}</small>
      {card.description && <p>{card.description}</p>}
      {card.previewStatus === 'pending' && !pendingTooLong && <small className="muted">Fetching preview…</small>}
      {(pendingTooLong || card.previewStatus === 'failed') && (
        <button className="link small" onPointerDown={(e) => e.stopPropagation()} onClick={onRetry}>
          Retry preview
        </button>
      )}
    </div>
  );
}
